import React from 'react';

const SCOPES = {
    signal: 'Тип по данным последней проверки',
    observation: 'Наблюдение, требует проверки',
    review: 'Тема текущего обращения, причина ещё проверяется',
    historical: 'Ранее наблюдавшийся сигнал; текущая неисправность не подтверждена',
};

const SIGNALS = {
    BILL_TIMEOUT: ['cash_acceptor', 'Купюроприёмник не ответил вовремя', 'Это не подтверждает текущую поломку. Приём настоящей купюры этой проверкой не проверялся.'],
    SERIAL_PRINTER_INVALID_FUNCTION: ['printing', 'Ошибка обмена с принтером', 'Физический выход бумаги этой записью не подтверждается.'],
    INCASSATION_PRINT_UNKNOWN: ['cash_collection', 'Неизвестен результат печати инкассации', 'Повторная инкассация для проверки не требуется.'],
    CRM_TLS_FAILURE: ['crm_sync', 'Ошибка защищённого соединения с CRM', 'Текущая доступность CRM проверяется отдельно.'],
    MAILBOX_FAILURE: ['crm_sync', 'Ошибка отправки данных в CRM', 'Результат доставки нужно проверять по состоянию очереди.'],
};

function signalTime(value) {
    const date = new Date(value);
    return value && Number.isFinite(date.getTime()) ? date.toLocaleString('ru-RU', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' }) : '';
}

export default function TerminalProblemTags({ tags = [], compact = false, signals = [], selectedType }) {
    if (!tags.length) return null;
    const selected = tags.find(tag => tag.id === selectedType);
    const notes = compact ? [] : signals.filter(signal => SIGNALS[signal.code] && tags.some(tag => tag.id === SIGNALS[signal.code][0]));
    return <div className={`tp-topics${compact ? ' compact' : ''}`}>
        {!compact ? <p>Типы проблем <small>Тема проверки, а не подтверждение поломки</small></p> : null}
        <div className="tp-tags" aria-label="Типы проблем">{tags.map(tag => <span key={tag.id} className={`tp-tag ${tag.scope}`} title={SCOPES[tag.scope] || SCOPES.review}>{tag.label}{tag.scope === 'historical' ? ' · ранее' : ''}</span>)}</div>
        {!compact && selected?.scope === 'historical' ? <p className="tp-filter-reason">В фильтре «{selected.label}» этот терминал показан по прошлому сигналу. Текущая неисправность этим сигналом не подтверждена.</p> : null}
        {notes.map(signal => <div className="tp-signal" key={signal.code}>
            <b>{SIGNALS[signal.code][1]}</b>
            <span>Сообщений в проверенном фрагменте журнала: {Number.isSafeInteger(signal.count) && signal.count > 0 ? signal.count : 'не указано'}.{signalTime(signal.lastSeen) ? ` Последнее: ${signalTime(signal.lastSeen)}.` : ''}</span>
            <span>{SIGNALS[signal.code][2]}</span>
        </div>)}
    </div>;
}
